// extracted by mini-css-extract-plugin
module.exports = {"button":"ChatButton_button__5gA8W"};